import axios from "axios";
import * as ActionType from "./slider.type";
import { apiInstanceFetch } from "../../../util/api";
import { setToast } from "../../../util/toast";

export const getSlider = () => (dispatch) => {
  apiInstanceFetch
    .get(`slider/getSliders`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_SLIDER,
        payload: res.sliders,
      });
    })
    .catch((error) => console.error(error));
};

// CREATE_SLIDER
export const createSlider = (formData) => (dispatch) => {
  axios
    .post(`slider/create`, formData)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.CREATE_SLIDER,
          payload: res.data.slider,
        });
        setToast("success", "Slider created successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error.message);
      setToast("error", "Failed to create slider");
    });
};

// UPDATE_SLIDER
export const updateSlider = (formData, id) => (dispatch) => {
  axios
    .patch(`slider/update?sliderId=${id}`, formData)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_SLIDER,
          payload: { data: res.data.slider, id },
        });
        setToast("success", "Slider updated successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error.message);
      setToast("error", "Failed to update slider");
    });
};

// DELETE_SLIDER
export const deleteSlider = (id) => (dispatch) => {
  axios
    .delete(`slider/delete?sliderId=${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.DELETE_SLIDER,
          payload: id,
        });
        setToast("success", "Slider deleted successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error.message);
      setToast("error", "Failed to delete slider");
    });
};
